import React from "react";
import Container from "./components/Container";

const App = () => <Container />;

export default App;